import {trackAmplitudeEvent} from "@pg-mono/amplitude";

export type AmplitudeViewPhotoNavigation = "initial" | "arrow_next" | "arrow_prev" | "swipe";
export type AmplitudeViewPhotoSection = "gallery" | "construction_photos" | "floor_plan";

export interface ITrackAmplitudeViewPhotoParams {
    location: string;
    offerId: number | string;
    propertyId?: number;
    photoIndex: number;
    photosTotal?: number;
    photoSection: AmplitudeViewPhotoSection;
    photoNavigation: AmplitudeViewPhotoNavigation;
}

export const trackAmplitudeViewPhoto = (params: ITrackAmplitudeViewPhotoParams) => {
    const {location, offerId, propertyId, photoIndex, photosTotal, photoSection, photoNavigation} = params;

    const eventProperties: Record<string, string | number> = {
        location,
        item_id: offerId,
        photo_index: photoIndex,
        photo_section: photoSection,
        photo_navigation: photoNavigation
    };

    if (propertyId != null) {
        eventProperties.property_id = propertyId;
    }
    if (photosTotal != null) {
        eventProperties.photos_total = photosTotal;
    }

    trackAmplitudeEvent("view_photo", eventProperties);
};
import {trackAmplitudeEvent} from "@pg-mono/amplitude";

export type AmplitudeViewPhotoNavigation = "initial" | "arrow_next" | "arrow_prev" | "swipe";
export type AmplitudeViewPhotoSection = "gallery" | "construction_photos" | "floor_plan";

export interface ITrackAmplitudeViewPhotoParams {
    location: string;
    offerId: number | string;
    propertyId?: number;
    photoIndex: number;
    photosTotal?: number;
    photoSection: AmplitudeViewPhotoSection;
    photoNavigation: AmplitudeViewPhotoNavigation;
}

export const trackAmplitudeViewPhoto = (params: ITrackAmplitudeViewPhotoParams) => {
    const {location, offerId, propertyId, photoIndex, photosTotal, photoSection, photoNavigation} = params;

    const eventProperties: Record<string, string | number> = {
        location,
        item_id: offerId,
        photo_index: photoIndex,
        photo_section: photoSection,
        photo_navigation: photoNavigation
    };

    if (propertyId != null) {
        eventProperties.property_id = propertyId;
    }
    if (photosTotal != null) {
        eventProperties.photos_total = photosTotal;
    }

    trackAmplitudeEvent("view_photo", eventProperties);
};
